import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import ContactForm from '../components/ContactForm';
import ModularBlocks from '../components/ModularBlocks';

const ContactPageTemplate = ({ data: { datoCmsContact } }) => {
  const {
    seoMetaTags,
    title,
    text,
    pardotFormUrl,
    pardotFormHeight,
    modularBlocks,
  } = datoCmsContact;

  return (
    <Layout seo={seoMetaTags} page={datoCmsContact}>
      <main>
        <ContactForm
          heading={title}
          text={text}
          pardotFormUrl={pardotFormUrl}
          pardotFormHeight={pardotFormHeight}
          isContactOrCallbackPage={true}
        />
        <ModularBlocks items={modularBlocks} />
      </main>
    </Layout>
  );
};

export const ContactPageTemplateQuery = graphql`
  query ContactPageTemplateQuery {
    datoCmsContact {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      text
      pardotFormUrl
      pardotFormHeight
      modularBlocks {
        ...FaqsModularBlockFragment
        ...FeaturedReviewsModularBlockFragment
      }
      ...LinkFragment
    }
  }
`;

export default ContactPageTemplate;
